import { ChevronDown } from '@atom-learning/icons'
import { Trigger } from '@radix-ui/react-collapsible'
import { Link } from '@radix-ui/react-navigation-menu'
import React from 'react'

import { Icon } from '~/components/icon/Icon'
import { styled } from '~/styled'

import { navigationMenuVerticalItemStyles } from './NavigationMenuVertical.styles'
import { NavigationMenuVerticalAccordionContext } from './NavigationMenuVerticalAccordion'
import { NavigationMenuVerticalItemContent } from './NavigationMenuVerticalItemContent'

const StyledNavigationMenuVerticalAccordionTrigger = styled(Trigger, {
  base: navigationMenuVerticalItemStyles,
  variants: {
    size: {
      md: ['min-h-10'],
      lg: ['min-h-12']
    }
  }
})

const StyledIcon = styled(Icon, {
  base: [
    'transition-transform',
    'duration-300',
    '[[data-state=open]>&]:rotate-180'
  ]
})

type TNavigationMenuAccordionTriggerProps = React.ComponentProps<
  typeof StyledNavigationMenuVerticalAccordionTrigger
>

export const NavigationMenuVerticalAccordionTrigger = ({
  children,
  ...rest
}: TNavigationMenuAccordionTriggerProps) => {
  const { setTriggerRef } = React.useContext(
    NavigationMenuVerticalAccordionContext
  )

  return (
    <Link asChild>
      <StyledNavigationMenuVerticalAccordionTrigger size="lg" {...rest} asChild>
        <button
          type="button"
          className="flex items-center justify-between gap-3"
          ref={setTriggerRef}
        >
          <NavigationMenuVerticalItemContent>
            {children}
          </NavigationMenuVerticalItemContent>
          <StyledIcon size="sm" is={ChevronDown} />
        </button>
      </StyledNavigationMenuVerticalAccordionTrigger>
    </Link>
  )
}
